import { render, staticRenderFns } from "./DeliveryStatusCard.vue?vue&type=template&id=35597457&scoped=true&"
import script from "./DeliveryStatusCard.vue?vue&type=script&lang=js&"
export * from "./DeliveryStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryStatusCard.vue?vue&type=style&index=0&id=35597457&lang=sass&scoped=true&"
import style1 from "./DeliveryStatusCard.vue?vue&type=style&index=1&lang=sass&"
import style2 from "./DeliveryStatusCard.vue?vue&type=style&index=2&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35597457",
  null
  
)

export default component.exports